export default {
  data () {
    return {
      products: []
    }
  },
  methods: {
    async deleteProduct (product) {
      if (confirm(`Produkt ${product.name} wirklich löschen?`)) {
        await this.initCsrf()

        this.$http.delete(`/products/${product.id}`).then(({ data }) => {
          this.$notify({
            message: `Produkt ${data.name} erfolgreich gelöscht.`,
            type: 'success'
          })
          const index = this.products.findIndex(({ id }) => data.id === id)
          this.products.splice(index, 1)
        })
      }
    }
  }
}
